import React from 'react';
import PropTypes from 'prop-types';
import '../../assets/scss/switch.css';

const Switch = ({ id, name, isOn, handleToggle, onColor }) => (
  <>
    <input
      id={id}
      name={name}
      checked={isOn}
      onChange={handleToggle}
      className="react-switch-checkbox"
      type="checkbox"
    />
    <label style={{ background: isOn && onColor }} className="react-switch-label mb-4" htmlFor={id}>
      <span className="react-switch-button" />
    </label>
  </>
);

export default Switch;
Switch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isOn: PropTypes.bool,
  handleToggle: PropTypes.func.isRequired,
  onColor: PropTypes.string.isRequired,
};

Switch.defaultProps = {
  isOn: false,
};
